import React from 'react';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Box
} from '@mui/material';
import {
    ExpandMore as ExpandMoreIcon,
    InfoOutlined as InfoIcon
} from '@mui/icons-material';

/**
 * Collapsible "How to read this report" notes. Sections come from the report
 * definition as [{ title, points: [...] }].
 */
const ReportGuide = ({ sections }) => {
    if (!sections || sections.length === 0) {
        return null;
    }

    return (
        <Accordion
            disableGutters
            elevation={0}
            sx={{ mb: 3, border: 1, borderColor: 'info.light', bgcolor: 'rgba(2, 136, 209, 0.04)', '&:before': { display: 'none' } }}
        >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <InfoIcon color="info" fontSize="small" />
                    <Typography variant="subtitle2">How to read this report</Typography>
                </Box>
            </AccordionSummary>
            <AccordionDetails sx={{ pt: 0 }}>
                {sections.map((section) => (
                    <Box key={section.title} sx={{ mb: 1.5 }}>
                        <Typography variant="subtitle2" color="primary" gutterBottom>
                            {section.title}
                        </Typography>
                        <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
                            {section.points.map((point) => (
                                <Typography component="li" variant="body2" key={point} sx={{ mb: 0.5 }}>
                                    {point}
                                </Typography>
                            ))}
                        </Box>
                    </Box>
                ))}
            </AccordionDetails>
        </Accordion>
    );
};

export default ReportGuide;
